export const dashboardRoutes = {
	dashboard: '/dashboard/'
}
